/** i18n 资源里的语言代码 → Intl BCP 47 locale */
const LANG_TO_LOCALE = {
  en: 'en-US',
  sc: 'zh-CN',
  tc: 'zh-TW',
  ge: 'de-DE',
  jp: 'ja-JP',
  ko: 'ko-KR',
  ar: 'ar',
  fr: 'fr-FR',
  es: 'es-ES',
  it: 'it-IT',
  pl: 'pl-PL',
  nl: 'nl-NL',
  pt: 'pt-PT',
  ro: 'ro-RO',
  vi: 'vi-VN',
  id: 'id-ID',
  th: 'th-TH',
  ms: 'ms-MY',
  ru: 'ru-RU',
};

/**
 * 将接口返回的 purchase_date 转为当前语言的短日期展示。
 * 无法解析时原样返回字符串。
 */
function parseToDate(input) {
  if (input == null) return null;
  const s = String(input).trim();
  if (!s) return null;

  // 中文/日文常见：2026年3月20日、2026年03月20日
  const cjkYmd = /^(\d{4})年(\d{1,2})月(\d{1,2})日/.exec(s);
  if (cjkYmd) {
    const y = Number(cjkYmd[1]);
    const m = Number(cjkYmd[2]) - 1;
    const d = Number(cjkYmd[3]);
    if (m >= 0 && m <= 11 && d >= 1 && d <= 31) {
      const dt = new Date(y, m, d);
      return isNaN(dt.getTime()) ? null : dt;
    }
  }

  const ymd = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
  if (ymd) {
    const y = Number(ymd[1]);
    const m = Number(ymd[2]) - 1;
    const d = Number(ymd[3]);
    const dt = new Date(y, m, d);
    return isNaN(dt.getTime()) ? null : dt;
  }

  const dt = new Date(s);
  if (!isNaN(dt.getTime())) return dt;

  return null;
}

export function isPurchaseDateOnOrAfter(input, thresholdYmd) {
  const d = parseToDate(input);
  const threshold = parseToDate(thresholdYmd);
  if (!d || !threshold) return false;
  return d.getTime() >= threshold.getTime();
}

export function formatPurchaseDate(input, i18nLanguage) {
  const locale = LANG_TO_LOCALE[i18nLanguage] || i18nLanguage || 'en-US';
  const d = parseToDate(input);
  if (!d) return input == null ? '' : String(input);

  try {
    return new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    }).format(d);
  } catch (e) {
    return String(input);
  }
}



// WEBPACK FOOTER //
// ./src/js/utils/formatPurchaseDate.js